import { AwardsApi } from '../clients';

/**
 * A 200 here does not mean every row applied — the endpoint continues past
 * per-row failures and reports them. Normalise failedRows so callers can render
 * the results panel without a null check.
 */
export const uploadMembershipsCsv = async (cycleId, file) => {
  const data = await AwardsApi.uploadMembershipsCsv(cycleId, file);

  return {
    updatedCount: data?.updatedCount ?? 0,
    removedCount: data?.removedCount ?? 0,
    unchangedCount: data?.unchangedCount ?? 0,
    failedRows: data?.failedRows ?? [],
  };
};
